import React, { useContext } from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ThemeContext from 'shared/context/ThemeContext';
import { TermsText } from './styledComponents';

const TiFormFooter = ({ handleOpenTerms }) => {
  const { FormFooter } = useContext(ThemeContext);

  return (
    <TermsText>
      {getText(TEXT_KEY.REGISTER_REWARD_TERMS_AGREE_MESSAGE)}{' '}
      <a style={FormFooter.TermsLink} onClick={handleOpenTerms}>
        {getText(TEXT_KEY.TERMS_OF_SERVICE)}
      </a>
    </TermsText>
  );
};

export default TiFormFooter;

